export default __webpack_public_path__ + "static/media/alert-circle.d962e5c8.svg";